import axios from "axios";
import Swal from 'sweetalert2';
import config from "../config";
/*  His produccion  */
// let apiUrl = `http://192.241.142.26:81`;

//  His Clinica Estancia
// let apiUrl = "http://192.168.203.61:8002";

//  His Clinica Estancia Production
// let apiUrl = "http://192.168.203.61:8010";

/*  His Cartagena  */
//let apiUrl = `http://10.20.4.4:83`

/*  His Local  */
// let apiUrl = `http://127.0.0.1:8000`

//clinica la estancia No
// let apiUrl = `http://192.168.203.243/his_osp_servicies`

//const tokenCons = localStorage.getItem("tokenReact");

//Variable de entorno
let apiUrl = config.API_URL

export const getCirugia = async (url) => {
	const tokenCons = localStorage.getItem("tokenReact");
	
	  return await axios.get(apiUrl + "/api/" + url, {
		headers: {
		  "Content-Type": "application/json",
		  Authorization: `Bearer ${tokenCons}`
		}
	  }).catch((error) => {  // Añadir paréntesis para definir correctamente la función
		if (error.response) {
		  const status = error.response.status;
		  switch (status) {
			case 403:
			  Swal.fire({
				icon: 'error',
				title: 'Error de permisos',
				text: 'El usuario no tiene permisos para esta acción.',
			  });
			  break;
			case 404:
			  Swal.fire({
				icon: 'error',
				title: 'Error de autorización',
				text: 'La consulta realizada no se encuentra registrada',
				showConfirmButton: false,
				timer: 4500,
				position: 'top-end'
			  });
			  break;
			case 500:
			  Swal.fire({
				icon: 'error',
				title: 'Error de conexión',
				text: 'No se pudo conectar con la base de datos. Por favor, inténtalo de nuevo más tarde.'
			  });
			  break;
			default:
			  break;
		  }
		} else {
		  Swal.fire({
			icon: 'error',
			title: 'Error',
			text: 'Se produjo un error inesperado.',
		  });
		}
		throw error;
	  });
	  
	
  }



  export const postCirugia = async (url, body) => {
	const tokenCons = localStorage.getItem("tokenReact");
	
	return await axios.post(apiUrl + "/api/" + url, body, {
		headers: {
		  "Content-Type": "application/json",
		  Authorization: `Bearer ${tokenCons}`
		}
	  }).catch((error) => {  // Añadir paréntesis para definir correctamente la función
		if (error.response) {
		  const status = error.response.status;
		  switch (status) {
			case 403:
			  Swal.fire({
				icon: 'error',
				title: 'Error de permisos',
				text: 'El usuario no tiene permisos para esta acción.',
			  });
			  break;
			case 404:
			  Swal.fire({
				icon: 'error',
				title: 'Error de autorización',
				text: 'La consulta realizada no se encuentra registrada',
				showConfirmButton: false,
				timer: 4500,
				position: 'top-end'
			  });
			  break;
			case 500:
			  Swal.fire({
				icon: 'error',
				title: 'Error de conexión',
				text: 'No se pudo conectar con la base de datos. Por favor, inténtalo de nuevo más tarde.'
			  });
			  break;
			default:
			  break;
		  }
		} else {
		  Swal.fire({
			icon: 'error',
			title: 'Error',
			text: 'Se produjo un error inesperado.',
		  });
		}
		throw error;
	  });
	  
	
  }


  
  

// export const postCirugia = async (url, body) => {
// 	const tokenCons = localStorage.getItem("tokenReact");
// 	return await axios.post(apiUrl + "/api/" + url, body, {
// 		headers: {
// 			"Content-Type": "application/json",
// 			Authorization: `Bearer ${tokenCons}`,
// 		},
// 	});
// };

export const UserTokenURL = () => {
	return apiUrl + `/api/seguridad/auth/user`;
};
